(function () {
  function initCroV3(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.croV3Ready === "true") {
      return;
    }

    sectionRoot.dataset.croV3Ready = "true";

    function syncStickyState(
      stickyButton,
      addToCartButton,
      stickyPrice,
      priceNode,
    ) {
      if (!stickyButton || !addToCartButton) {
        return;
      }

      var isDisabled =
        addToCartButton.disabled ||
        addToCartButton.getAttribute("aria-disabled") === "true";
      stickyButton.disabled = isDisabled;
      stickyButton.setAttribute("aria-disabled", isDisabled ? "true" : "false");

      if (stickyPrice && priceNode) {
        var priceText = (priceNode.textContent || "").trim();
        if (priceText) {
          stickyPrice.textContent = priceText;
        }
      }
    }

    function syncFidelityPoints(priceNode, fidelityNode) {
      if (!priceNode || !fidelityNode) {
        return;
      }

      var priceText = (priceNode.textContent || "").trim();
      var numeric = priceText.replace(/[^\d,.-]/g, "").replace(",", ".");
      var value = parseFloat(numeric);

      if (!isNaN(value)) {
        fidelityNode.textContent = Math.round(value) + " points";
      }
    }

    sectionRoot
      .querySelectorAll("[data-cro3-acc-trigger]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          var body = button.nextElementSibling;
          var icon = button.querySelector(".product-cro-v3__acc-icon");
          var open = body && body.classList.toggle("is-open");

          if (icon) {
            icon.classList.toggle("is-open", open);
            icon.textContent = open ? "−" : "+";
          }

          button.setAttribute("aria-expanded", open ? "true" : "false");
        });
      });

    var stickyBar = sectionRoot.querySelector("[data-product-cro-v3-sticky]");
    var stickyButton = sectionRoot.querySelector(
      "[data-product-cro-v3-sticky-button]",
    );
    var mainCtaButton = sectionRoot.querySelector(
      "[data-product-cro-v3-main-cta]",
    );
    var stickyPrice = sectionRoot.querySelector(
      ".product-cro-v3__sticky-price",
    );
    var priceNode = sectionRoot.querySelector(".product-cro-v3__price");
    var ctaPrice = sectionRoot.querySelector("[data-product-cro-v3-cta-price]");
    var fidelityNode = sectionRoot.querySelector(
      "[data-product-cro-v3-fidelity-points]",
    );
    var variantSelect = sectionRoot.querySelector("select[data-variants]");
    var variantPills = sectionRoot.querySelectorAll("[data-cro3-variant-pill]");
    var addToCartButton = sectionRoot.querySelector(
      "[data-add-to-cart-trigger], .button--add-to-cart",
    );

    // Les boutons visibles (CTA principal, barre sticky) déclenchent le vrai bouton du
    // formulaire, qui est masqué. L'ajout au panier en AJAX ne vérifie pas les champs
    // obligatoires (recommande de parfum, gravure…) : on les valide avant de l'appeler.
    function submitProductForm() {
      var productForm = addToCartButton && addToCartButton.form;
      if (productForm && !productForm.checkValidity()) {
        var firstInvalid = productForm.querySelector(":invalid:not(fieldset)");
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
          firstInvalid.focus({ preventScroll: true });
        }
        productForm.reportValidity();
        return;
      }
      addToCartButton.click();
    }

    function syncVariantPills(activeVariantId) {
      if (!variantPills || !variantPills.length) {
        return;
      }

      variantPills.forEach(function (pill) {
        var isActive =
          String(pill.getAttribute("data-variant-id")) ===
          String(activeVariantId);
        pill.classList.toggle("is-active", isActive);
        pill.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function syncDisplayedPriceFromVariant(activeVariantId) {
      if (!priceNode) {
        return;
      }

      var selectedPill = sectionRoot.querySelector(
        '[data-cro3-variant-pill][data-variant-id="' +
          String(activeVariantId) +
          '"]',
      );

      var priceText = selectedPill
        ? selectedPill.getAttribute("data-variant-price")
        : "";

      if (!priceText && variantSelect) {
        var selectedOption =
          variantSelect.options &&
          variantSelect.selectedIndex >= 0 &&
          variantSelect.options[variantSelect.selectedIndex];
        if (selectedOption && selectedOption.textContent) {
          var optionParts = selectedOption.textContent.split(" - ");
          if (optionParts.length > 1) {
            priceText = optionParts[optionParts.length - 1].trim();
          }
        }
      }

      if (!priceText) {
        return;
      }

      priceNode.textContent = priceText;
      if (stickyPrice) {
        stickyPrice.textContent = priceText;
      }
      if (ctaPrice) {
        ctaPrice.textContent = "— " + priceText;
      }
      syncFidelityPoints(priceNode, fidelityNode);
    }

    if (variantPills && variantPills.length && variantSelect) {
      variantPills.forEach(function (pill) {
        pill.addEventListener("click", function () {
          var variantId = pill.getAttribute("data-variant-id");
          if (!variantId || pill.disabled) {
            return;
          }

          variantSelect.value = variantId;
          syncVariantPills(variantId);
          syncDisplayedPriceFromVariant(variantId);

          variantSelect.dispatchEvent(
            new Event("change", {
              bubbles: true,
            }),
          );
        });
      });

      syncVariantPills(variantSelect.value);
      variantSelect.addEventListener("change", function () {
        syncVariantPills(variantSelect.value);
        syncDisplayedPriceFromVariant(variantSelect.value);
      });
      syncDisplayedPriceFromVariant(variantSelect.value);
    } else {
      syncFidelityPoints(priceNode, fidelityNode);
    }

    if (stickyButton && addToCartButton) {
      syncStickyState(stickyButton, addToCartButton, stickyPrice, priceNode);

      stickyButton.addEventListener("click", function () {
        submitProductForm();
      });

      sectionRoot.addEventListener("change", function () {
        window.requestAnimationFrame(function () {
          syncStickyState(
            stickyButton,
            addToCartButton,
            stickyPrice,
            priceNode,
          );
        });
      });
    }

    if (mainCtaButton && addToCartButton) {
      mainCtaButton.addEventListener("click", function () {
        submitProductForm();
      });

      sectionRoot.addEventListener("change", function () {
        window.requestAnimationFrame(function () {
          var isDisabled =
            addToCartButton.disabled ||
            addToCartButton.getAttribute("aria-disabled") === "true";
          mainCtaButton.disabled = isDisabled;

          var priceText = (
            priceNode && priceNode.textContent ? priceNode.textContent : ""
          ).trim();
          if (priceText && ctaPrice) {
            ctaPrice.textContent = "— " + priceText;
          }
          syncFidelityPoints(priceNode, fidelityNode);
        });
      });

      window.requestAnimationFrame(function () {
        var isDisabled =
          addToCartButton.disabled ||
          addToCartButton.getAttribute("aria-disabled") === "true";
        mainCtaButton.disabled = isDisabled;
      });
    }

    if (
      !stickyBar ||
      !addToCartButton ||
      typeof IntersectionObserver === "undefined"
    ) {
      return;
    }

    // Desktop : la barre sticky reprend exactement la colonne de contenu de la
    // buy-zone. On mesure la position réelle plutôt que de la calculer en CSS
    // (scrollbar, marges du conteneur, largeur max de la page...).
    var buyZone = sectionRoot.querySelector(".product-cro-v3__buy-zone");
    var desktopQuery = window.matchMedia("(min-width: 1024px)");
    var isAlignScheduled = false;

    function alignStickyBar() {
      isAlignScheduled = false;

      if (!buyZone || !desktopQuery.matches) {
        stickyBar.style.removeProperty("--cro3-sticky-left");
        stickyBar.style.removeProperty("--cro3-sticky-width");
        stickyBar.style.removeProperty("--cro3-sticky-right");
        return;
      }

      stickyBar.style.setProperty("--cro3-sticky-right", "auto");

      var rect = buyZone.getBoundingClientRect();
      var styles = window.getComputedStyle(buyZone);
      var paddingLeft = parseFloat(styles.paddingLeft) || 0;
      var paddingRight = parseFloat(styles.paddingRight) || 0;

      stickyBar.style.setProperty(
        "--cro3-sticky-left",
        rect.left + paddingLeft + "px",
      );
      stickyBar.style.setProperty(
        "--cro3-sticky-width",
        rect.width - paddingLeft - paddingRight + "px",
      );
    }

    function scheduleAlign() {
      if (isAlignScheduled) {
        return;
      }

      isAlignScheduled = true;
      window.requestAnimationFrame(alignStickyBar);
    }

    alignStickyBar();
    window.addEventListener("resize", scheduleAlign);
    window.addEventListener("load", scheduleAlign);

    if (typeof ResizeObserver !== "undefined" && buyZone) {
      // documentElement : détecte aussi l'apparition / disparition de la scrollbar
      var alignObserver = new ResizeObserver(scheduleAlign);
      alignObserver.observe(buyZone);
      alignObserver.observe(document.documentElement);
    }

    var observerTarget = mainCtaButton || addToCartButton;
    var isMainCtaIntersecting = true;
    var isFooterIntersecting = false;
    var isGuardedZoneUnderBar = false;

    // Prix, choix du format (Flacon / Roll-on) et « Associez-le » (boutons d'ajout) :
    // la barre ne s'affiche jamais par-dessus.
    // Sur un petit écran, le CTA principal peut être sous la ligne de flottaison alors que
    // le prix est en bas de l'écran : on attend qu'il soit sorti de la zone de la barre.
    var guardedNodes = sectionRoot.querySelectorAll(
      ".product-cro-v3__price-row, .product-cro-v3__vol-selector, .product-cro-v3__cross",
    );

    function getBarTop() {
      var bottomOffset = desktopQuery.matches ? 24 : 0;
      return window.innerHeight - bottomOffset - stickyBar.offsetHeight - 8;
    }

    function updateStickyVisibility() {
      var shouldShow =
        !isMainCtaIntersecting && !isFooterIntersecting && !isGuardedZoneUnderBar;
      stickyBar.classList.toggle("product-cro-v3__sticky--visible", shouldShow);
      stickyBar.classList.toggle(
        "product-cro-v3__sticky--blocked",
        isFooterIntersecting,
      );
    }

    // Bas des éléments fixes du haut de page (header desktop, header mobile,
    // bandeau d'annonce) : le CTA principal est considéré comme masqué dès
    // qu'il passe dessous.
    var fixedTopElements = document.querySelectorAll(
      "#header, #mobile-header, .announcement-bar__container",
    );

    function getHeaderBottom() {
      var bottom = 0;

      fixedTopElements.forEach(function (element) {
        var position = window.getComputedStyle(element).position;
        if (position !== "fixed" && position !== "sticky") {
          return;
        }

        var rect = element.getBoundingClientRect();
        if (rect.height > 0 && rect.top < window.innerHeight / 2) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });

      return bottom;
    }

    var isCheckScheduled = false;

    function checkMainCta() {
      isCheckScheduled = false;
      var rect = observerTarget.getBoundingClientRect();
      isMainCtaIntersecting =
        rect.top >= getHeaderBottom() && rect.top < window.innerHeight;

      var barTop = getBarTop();
      isGuardedZoneUnderBar = Array.prototype.some.call(
        guardedNodes,
        function (node) {
          var nodeRect = node.getBoundingClientRect();
          return (
            nodeRect.height > 0 &&
            nodeRect.bottom > barTop &&
            nodeRect.top < window.innerHeight
          );
        },
      );
      updateStickyVisibility();
    }

    function scheduleCheck() {
      if (isCheckScheduled) {
        return;
      }

      isCheckScheduled = true;
      window.requestAnimationFrame(checkMainCta);
    }

    window.addEventListener("scroll", scheduleCheck, { passive: true });
    window.addEventListener("resize", scheduleCheck);
    checkMainCta();

    var footerTarget = document.querySelector(
      "footer, .shopify-section-group-footer-group, .shopify-section-footer, #shopify-section-footer, [data-section-type='footer']",
    );

    if (footerTarget) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          var first = entries && entries[0];
          if (!first) {
            return;
          }

          isFooterIntersecting = !!first.isIntersecting;
          updateStickyVisibility();
        },
        {
          threshold: 0,
        },
      );

      footerObserver.observe(footerTarget);
    }
  }

  function initAll() {
    document.querySelectorAll("[data-product-cro-v3]").forEach(initCroV3);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
